import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { Policy } from "src/app/shared/models/policy.interface";
import { PolicyApiService } from "src/app/shared/services/policy-api.service";
import {PdfViewerComponent} from "../../ pdf-viewer/pdf-viewer.component";
import { environment } from "src/environments/environment";

@Component({
    selector: "app-policy",
    standalone: true,
    imports: [CommonModule, PdfViewerComponent, TranslateModule],
    templateUrl: "./policy.component.html",
    styleUrl: "./policy.component.scss",
})
export class PolicyComponent implements OnInit {
    policy!: Policy;
    safeContent!: SafeHtml;
    pdfUrl = "";
    isPdf = false;
    titleKey = "";
    forbiddenKeywords: string[] = [];

    constructor(
        private route: ActivatedRoute,
        private sanitizer: DomSanitizer,
        private policyService: PolicyApiService
    ) {}

ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
        const key = params.get("slug");
        if (!key) return;

        this.titleKey = key.toLowerCase() === "forbiddenkeywords"
            ? "FOOTER.PROHIBITED_KEYWORDS"
            : "";

        this.policyService.getPolicyByKey(key).subscribe((res) => {
            if (res?.success) {
                this.policy = res.data;
                const content = this.policy.content || this.policy.description || "";
                this.forbiddenKeywords = this.titleKey
                    ? content.split("|")
                    : [];

                this.isPdf = content.endsWith(".pdf") || content.includes("policy-documents");

                if (this.isPdf) {
                    this.pdfUrl = content.startsWith("http")
                        ? content
                        : `${environment.apiURL}${content}`;
                } else {
                    this.safeContent = this.sanitizer.bypassSecurityTrustHtml(
                        this.autoLink(content)
                    );
                }
            }
        });
    });
}

    autoLink(text: string): string {
        const urlRegex = /https?:\/\/[^\s"'<]+/g;
        return text.replace(
            urlRegex,
            (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
        );
    }
}